import { datadogRum } from '@datadog/browser-rum';

import { Warnings } from '../types/warnings';

export const addWarning = (name: Warnings, context?: Record<string, unknown>) => {
  datadogRum.addAction(`WARNING_${Warnings[name]}`, { type: 'warning', ...context });
};
